import { render, staticRenderFns } from "./AbsoluteLayout.vue?vue&type=template&id=6fc2e5d6&"
import script from "./AbsoluteLayout.vue?vue&type=script&lang=js&"
export * from "./AbsoluteLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports